// @ts-nocheck
import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import zhCN from "antd/es/locale/zh_CN";
import reduxThunk from "redux-thunk";
import { BrowserRouter as Router } from "react-router-dom";
import MenuLayout from "./pages/menuLayout";
import reducer from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(reduxThunk))
);

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Provider store={store}>
          <MenuLayout />
        </Provider>
      </Router>
    </ConfigProvider>
  );
}

export default App;
